angular.module('tf.services')

    .factory('SessionStorageService', function($window){

        var service = {};
        var sessionStorage =  $window.sessionStorage;
        service.getObject = function(key){
            try {
                return JSON.parse(this.getString(key));
            }catch (e) {
                return undefined;
            }
        };
        service.getObjectAndRemove = function(key){
            var obj = JSON.parse(this.getString(key));
            this.removeItem(key);
            return obj;
        };
        service.getString = function(key){
            return sessionStorage.getItem(key);
        };
        service.setItem = function(key, value) {
            if (typeof value === 'string') {
                sessionStorage.setItem(key, value); // Store string directly
            } else {
                sessionStorage.setItem(key, JSON.stringify(value)); 
            }
        };
        service.hasValue = function(key){
            return !!this.getString(key);
        };
        service.removeItem = function(key){
            sessionStorage.removeItem(key);
        };

        return service;
    })
;
